import React from 'react';
import { Box, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import HandshakeIcon from '@mui/icons-material/Handshake';
import PeopleIcon from '@mui/icons-material/People';
import WorkIcon from '@mui/icons-material/Work';
import './sidebar.css';

const Sidebar = () => {
  const location = useLocation();

  const menuItems = [
    { text: 'Dashboard', icon: <HomeIcon />, path: '/dashboard' },
    { text: 'Startup path', icon: <TrendingUpIcon />, path: '/member' },
    { text: 'Partner Us', icon: <HandshakeIcon />, path: '/partnerwithus' },
    { text: 'Volunteer', icon: <PeopleIcon />, path: '/volunteer' },
    { text: 'Career', icon: <WorkIcon />, path: '/career' },
  ];

  return (
    <Box className="sidebar-container">
      {/* 1. TOP: Logo */}
      <Link to="/dashboard" style={{ textDecoration: 'none' }}>
        <Box className="sidebar-logo-box">
          <Typography variant="h5" className="sidebar-logo-text">Markoknow</Typography>
        </Box>
      </Link>

      {/* 2. MIDDLE: Nav List */}
      <List className="sidebar-list">
        {menuItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <ListItem 
              button 
              key={item.text} 
              component={Link} 
              to={item.path}
              className={`sidebar-item ${isActive ? 'active' : ''}`}
            >
              <ListItemIcon className="sidebar-icon">{item.icon}</ListItemIcon>
              <ListItemText 
                primary={item.text} 
                primaryTypographyProps={{ fontWeight: 600, fontSize: '0.9rem' }}
              />
            </ListItem>
          );
        })}
      </List>

      {/* 3. BOTTOM: Footer (margin-top: auto pins this) */}
      <Box className="sidebar-footer">
        <Typography variant="body2" component={Link} to="/account" className="footer-link">
          My Account
        </Typography>
        <Typography variant="body2" component={Link} to="/contact" className="footer-link">
          Contact us
        </Typography>
        <Typography variant="body2" component={Link} to="/refer" className="footer-link">
          Refer a friend
        </Typography>
      </Box>
    </Box>
  );
};

export default Sidebar;